import { render, staticRenderFns } from "./variazioni.vue?vue&type=template&id=05b51b97&scoped=true"
import script from "./variazioni.vue?vue&type=script&lang=js"
export * from "./variazioni.vue?vue&type=script&lang=js"
import style0 from "./variazioni.vue?vue&type=style&index=0&id=05b51b97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b51b97",
  null
  
)

export default component.exports